import { getRecordList } from '@src/utils/media-data';
import OptionalImage from '@src/components/optional-image';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Link from '@src/components/link';
import cx from 'classnames';
import Part3Store from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
const styles = require('./index.less');

const Part3 = ({ onPlayVideo }) => {
  const store = useStore(() => new Part3Store());
  const sectSwiper = useMemo(
    () => {
      if (!getRecordList(store.sectData).length) return null;
      return (
        <div className={styles.sectSwiper}>
          <BaseSwiper store={store.sectSwiperStore}>
            {getRecordList(store.sectData).map((item, index) => (
              <div key={index} className={styles.sectSwiperItem}>
                <OptionalImage src={item.role} alt={item.name} className={styles.sectSwiperItemRole} />
                <OptionalImage src={item.title} alt={item.name} className={styles.sectSwiperItemTitle} />
                <OptionalImage src={item.parameter} alt={item.name} className={styles.sectSwiperItemParameter} />
                <OptionalImage src={item.positioning} alt={item.name} className={styles.sectSwiperItemPositioning} />
                <OptionalImage src={item.weapon} alt={item.name} className={styles.sectSwiperItemWeapon} />
                {item.video && <Link className={styles.sectSwiperItemVideo} data-id="sectVideo" data-video-url={item.video} />}
              </div>
            ))}
          </BaseSwiper>
        </div>
      );
    },
    [store.sectData]
  );
  const sectTabs = useMemo(
    () => {
      if (!getRecordList(store.sectData).length) return null;
      return (
        <div className={styles.tab}>
          {getRecordList(store.sectData).map((item, index) => {
            const notLastItem = index !== getRecordList(store.sectData).length - 1;
            return (
              <React.Fragment key={index}>
                <div className={cx(styles.tab_item, { [styles.active]: store.activeSectIndex === index })} onClick={() => store.onChangeSectIndex(index)}>
                  <OptionalImage className={styles.poem_icon_img} src={item.tab} alt="门派" />
                  <OptionalImage className={styles.poem_selected_icon_img} src={item.activeTab} alt="选中的门派" />
                  <img className={styles.poem_selected_border1_img} src={require('./images/border-active1.png')} alt="选中的图标内框icon" />
                  <img className={styles.poem_selected_border2_img} src={require('./images/border-active2.png')} alt="选中的图标边框icon" />
                </div>
                {notLastItem && <img className={styles.item_line} src={require('./images/line.png')} alt="线" loading="lazy" fetchpriority="low" />}
              </React.Fragment>
            );
          })}
        </div>
      );
    },
    [store.sectData, store.activeSectIndex]
  );
  return (
    <div className={styles.part3Root}>
      <div className={styles.part3Title} />
      {sectSwiper}
      {sectTabs}
    </div>
  );
};

export default observer(Part3);
